import type { ExtensionState, LiveCallStatus } from '../contract'

export const lampColor = (s: ExtensionState): string => {
  switch (s) {
    case 'not_in_use': return 'var(--lamp-idle)'
    case 'in_use': case 'busy': return 'var(--lamp-busy)'
    case 'ringing': return 'var(--lamp-ring)'
    case 'on_hold': return 'var(--lamp-hold)'
    default: return 'var(--lamp-unavail)'
  }
}

export const callLampColor = (s: LiveCallStatus): string => {
  switch (s) {
    case 'connected': return 'var(--lamp-idle)'
    case 'ringing': return 'var(--lamp-ring)'
    case 'on_hold': case 'parked': return 'var(--lamp-hold)'
    default: return 'var(--lamp-unavail)'
  }
}

const LABELS: Record<string, string> = {
  not_in_use: 'idle', in_use: 'in use', busy: 'busy', ringing: 'ringing', on_hold: 'on hold',
  unavailable: 'unavail', invalid: 'invalid', unknown: 'unknown',
  connected: 'connected', parked: 'parked', ended: 'ended',
  inbound: 'inbound', outbound: 'outbound', internal: 'internal'
}
export const label = (v: string): string => LABELS[v] ?? v

export const Lamp = ({ color }: { color: string }) => (
  <span className="lamp" style={{ background: color }} aria-hidden />
)

export const prettyNumber = (n: string): string => {
  if (!n) return ''
  const d = n.replace(/[^\d+]/g, '')
  const m = d.match(/^\+?1?(\d{3})(\d{3})(\d{4})$/)
  return m ? `(${m[1]}) ${m[2]}-${m[3]}` : n
}
